import React from 'react';
import { Redirect } from 'react-router-dom';

import Dashboard from '../pages/dashboard/DashboardScreen';
import SalesPlan from '../pages/SalesPlan/SalesPlanScreen';
import RollingPlan from '../pages/RollingPlan/RollingPlanScreen';
import RunRatePlan from '../pages/run-rate-plan/RunRatePlanScreen';
import StrategicPlan from '../pages/StrategicPlan/StrategicPlanScreen';
import ManageProduct from '../pages/ManageProduct/ManageProductScreen';
import ValidStore from '../pages/ValidStore/ValidStoreScreen';
import SKULevelSalesPlan from '../pages/SKULevelSalesPlan/SKULevelSalesPlanScreen';
import SKULevelRollingPlan from '../pages/SKULevelRollingPlan/SKULevelRollingPlanScreen';
import SeasonConfiguration from '../pages/season-configuration/SeasonConfigurationScreen';
import PlanningWindowConfiguration from '../pages/planning-window-configuration/PlanningWindowConfigurationScreen';
import DigitalProductCatalog from '../pages/ManageProduct/DigitalProductCatalog/DigitalProductCatalogScreen';
import { SalesPlanEditAll } from '../pages/SalesPlan/edit-all/edit-all-screen';
import { RollingPlanEditAll } from '../pages/RollingPlan/edit-all/edit-all-screen';
import { StrategicPlanEditAll } from '../pages/StrategicPlan/edit-all/edit-all-screen';
import SKULevelSalesPlanEditAll from '../pages/sku-level-sales-plan-edit-all/SKULevelSalesPlanEditAllScreen';
import SKULevelRollingPlanEditAll from '../pages/sku-level-rolling-plan-edit-all/SKULevelRollingPlanEditAllScreen';
import UsageReport from '../pages/dashboard/UsageReport';

const authProtectedRoutes = [
  {
    path: '/dashboard',
    component: Dashboard
  },
  {
    path: '/usageReport',
    component: UsageReport
  },
  {
    path: '/sales-plan',
    component: SalesPlan,
    children: [
      {
        path: '/sales-plan/edit-all',
        component: SalesPlanEditAll
      }
    ]
  },
  {
    path: '/rolling-plan',
    component: RollingPlan,
    children: [
      {
        path: '/rolling-plan/edit-all',
        component: RollingPlanEditAll
      }
    ]
  },
  {
    path: '/run-rate-plan',
    component: RunRatePlan,
    children: []
  },
  {
    path: '/strategic-plan',
    component: StrategicPlan,
    children: [
      {
        path: '/strategic-plan/edit-all',
        component: StrategicPlanEditAll
      }
    ]
  },
  {
    path: '/manage-single-select-product',
    component: ManageProduct,
    children: [
      {
        path: '/manage-single-select-product/digital-single-select-product-catalog',
        component: DigitalProductCatalog
      }
    ]
  },
  {
    path: '/sku-level-sales-plan',
    component: SKULevelSalesPlan,
    children: [
      {
        path: '/sku-level-sales-plan/digital-single-select-product-catalog',
        component: DigitalProductCatalog
      }
    ]
  },
  {
    path: '/sku-level-sales-plan-edit-all',
    component: SKULevelSalesPlanEditAll,
  },
  {
    path: '/sku-level-rolling-plan-edit-all',
    component: SKULevelRollingPlanEditAll,
  },
  {
    path: '/sku-level-rolling-plan',
    component: SKULevelRollingPlan,
    children: [
      {
        path: '/sku-level-rolling-plan/digital-single-select-product-catalog',
        component: DigitalProductCatalog
      }
    ]
  },
  {
    path: '/season-configuration',
    component: SeasonConfiguration
  },
  {
    path: '/planning-window-configuration',
    component: PlanningWindowConfiguration
  },
  {
    path: '/valid-store',
    component: ValidStore
  },
  {
    path: '/',
    exact: true,
    component: () => <Redirect to='/dashboard'/>
  }
];

export { authProtectedRoutes };
